
/**
 * @export
 * @enum {string}
 */
export enum PricingModel {
    SUBSCRIPTION = 'SUBSCRIPTION',
    PAY_PER_CALL = 'PAY_PER_CALL',
    INTEGRATION = 'INTEGRATION'
}